import { Instagram, Facebook, Globe, MessageCircle } from "lucide-react";
import { CONTACT, waLink, WA_MESSAGES } from "./data";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#121a23] border-t border-white/5 py-14">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-10">
          <div>
            <img src="/images/logo_horizontal.webp" alt="Condominio EHÉCATL" className="h-11 w-auto mb-4" />
            <p className="text-sm text-[#a8ac9b] max-w-sm leading-relaxed">{CONTACT.address}</p>
          </div>
          <div className="flex flex-col gap-4">
            <a data-testid="footer-whatsapp" href={waLink(WA_MESSAGES.general)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-3 text-sm text-[#ddc68c] link-line w-fit">
              <MessageCircle size={16} /> WhatsApp {CONTACT.phone}
            </a>
            <a data-testid="footer-web" href="https://condominioehecatl.com/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-3 text-sm text-[#a8ac9b] hover:text-[#f4f2ea] transition-colors w-fit">
              <Globe size={16} /> {CONTACT.web}
            </a>
            <div className="flex items-center gap-4 mt-1">
              <a data-testid="footer-instagram" href={CONTACT.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="p-2.5 rounded-full border border-white/10 text-[#a8ac9b] hover:text-[#ddc68c] hover:border-[#bfa360]/50 transition-colors">
                <Instagram size={17} />
              </a>
              <a data-testid="footer-facebook" href={CONTACT.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="p-2.5 rounded-full border border-white/10 text-[#a8ac9b] hover:text-[#ddc68c] hover:border-[#bfa360]/50 transition-colors">
                <Facebook size={17} />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 mono text-[10px] uppercase tracking-[0.2em] text-[#5f6459]">
          <p>© {new Date().getFullYear()} Condominio EHÉCATL · Un desarrollo de PRODECOM</p>
          <p>Información de carácter informativo, sujeta a cambios sin previo aviso</p>
        </div>
      </div>
    </footer>
  );
}
